__turbopack_context__.v({
  "carousel": "LeaderboardsHomeBlock-module__OfGCgG__carousel",
  "container": "LeaderboardsHomeBlock-module__OfGCgG__container",
  "grid": "LeaderboardsHomeBlock-module__OfGCgG__grid",
  "hidden": "LeaderboardsHomeBlock-module__OfGCgG__hidden",
  "nextButton": "LeaderboardsHomeBlock-module__OfGCgG__nextButton",
  "scrollArea": "LeaderboardsHomeBlock-module__OfGCgG__scrollArea",
});
